<template>
  <div id="page">
    <div class="share_head clear">
      <div class="share_user_icon lt">
        <img class="lt" :src="iconUrl" alt="">
        <div class="share_user_info lt">
          <p>{{userName}}</p>
          <p>邀请你体验AR,一起来捉妖</p>
        </div>
      </div>
      <input class="share_button rt" type="button" value="打开来啊" @click="downloadApp">
    </div>
    <img class="share_content" src="../img/share.jpg" alt="">
    <input class="download_button rt" type="button" value="下载来啊开始捉妖吧" @click="downloadApp">
    <div class="weChat" v-if="isWeChat" @click='isWeChat=!isWeChat'>
      <div>
        <img style="width: 80%;" alt="" src="http://cunba-common.yeedian365.com/web_resources/live_weixin.png">
      </div>
    </div>
  </div>
</template>

<script>
  import MescrollVue from 'mescroll.js/mescroll.vue'
  export default {
    name: 'ProfitDetails',
    components: {
      MescrollVue // 注册mescroll组件
    },
    data() {
      return {
        userId: '',
        downloadUrl: '',
        userName: '好友昵称',
        iconUrl: 'http://dig-mineral.yeedian365.com/icon_page/img/icon.png',
        cbId: '',
        isWeChat: false,
      }
    },
    mounted() {
      if (this.$route.query.user_id) {
        this.userId = decodeURI(this.$route.query.user_id);
      }
      this.$axios.post("user/getSharePageData.do", {
        "user_id": this.userId,
      }).then((res) => {
        // console.log(res);
        this.userName = res.data.nick_name == undefined ? this.userName : res.data.nick_name;
        this.iconUrl = res.data.icon_url == undefined ? this.iconUrl : res.data.icon_url;
        this.cbId = res.data.cb_id == undefined ? this.cbId : res.data.cb_id;
        this.downloadUrl = res.data.download_url;
      }).catch((e) => {
        //联网失败的回调,隐藏下拉刷新和上拉加载的状态;
      })
    },
    methods: {
      downloadApp() {
        var u = navigator.userAgent;
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.isWeChat = !this.isWeChat;
          } else {
            window.location.href = this.downloadUrl;
          }
        }
        if (isiOS) {
           alert('暂无ios版本！');
        }
      }
    }
  }
</script>

<style>
  .share_head {
    background-color: #0b0a4b;
    height: 2rem;
    padding: 0 0.3rem;
    color: #fff;
  }

  .share_user_icon {
    padding-top: 0.2rem;
  }

  .share_user_icon img {
    width: 1.5rem;
    height: 1.5rem;
    border: 0.1rem solid #3771fa;
    border-radius: 1.4rem;
    background-color: #3771fa;
  }

  .share_user_info {
    margin-left: 0.3rem;
    margin-top: 0.2rem;
    font-size: 0.44rem;
  }

  .share_user_info p:last-child {
    font-size: 0.4rem;
  }

  .share_button {
    width: 3rem;
    height: 1rem;
    color: #fff;
    font-size: 0.4rem;
    letter-spacing: 1px;
    border: 1px solid #fff;
    background: #3771fa;
    border-radius: 0.1rem;
    margin-top: 0.5rem;
  }

  .share_content {
    width: 100vw;
  }

  .download_button {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 1rem;
    width: 80%;
    height: 1.2rem;
    color: #fff;
    font-size: 0.48rem;
    font-weight: bold;
    letter-spacing: 1px;
    border: 1px solid #fff;
    border-radius: 0.1rem;
    background-color: #3771fa;
    margin: 0 auto;
  }

  .weChat {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    filter: alpha(opacity=80);
    width: 100%;
    height: 100%;
    z-index: 100;
  }

  .weChat div {
    text-align: right;
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Share.vue